import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const deleteEndpoint = ApiEndpoints.team.Delete;
const listEndpoint = ApiEndpoints.team.List;
const editPath = "edit-team";
const tableHeader = ["Date","Name","Designation"];
const tbody = ["createdAt","name","designation"];

export default function Teams() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.teams;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (team_id) => {
    const payload = { team_id };
    try {
      const response = await ApiRequest("POST", deleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Team Management',
    user: 'Admin',
    innerpage: 'News Management / Team'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section">
      <Link className="admin-add-btn" to="/add-team">Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        editPath={editPath}
        onDelete={handleDelete}
      />
    </div>
    </>
  )
}
